import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-guild-avatar',
  standalone: true,
  templateUrl: './guild-avatar.component.html',
  styleUrl: './guild-avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuildAvatarComponent implements OnInit {
  @Input() type: 'default' | 'small' = 'default';
  @Input() logoUrl?: string;
  @Input() customWidth: string | null = null;
  @Input() customHeight: string | null = null;
  @Input() customTop: string | null = null;
  @Input() customMaskSize: string | null = null;

  @Output() editLogo: EventEmitter<void> = new EventEmitter();

  ngOnInit(): void {
    if (!this.customMaskSize && this.type === 'small') {
      this.customMaskSize = '20px';
    }
  }
}
